import { z } from 'zod'

/**
 * Override-rate analytics — shapes for:
 * GET /api/v1/hr/override-rate?from=&to=&group_by=manager|reason|month
 *
 * HR / Director / Exec Director only.
 */

export const overrideRateGroupBySchema = z.enum(['manager', 'reason', 'month'])
export type OverrideRateGroupBy = z.infer<typeof overrideRateGroupBySchema>

export const overrideRateTotalsSchema = z.object({
  decisions_total: z.number().int().nonnegative(),
  overrides_total: z.number().int().nonnegative(),
  override_rate_pct: z.number().min(0).max(100),
})
export type OverrideRateTotals = z.infer<typeof overrideRateTotalsSchema>

export const overrideRateRowSchema = z.object({
  label: z.string(),
  decisions: z.number().int().nonnegative(),
  overrides: z.number().int().nonnegative(),
  rate_pct: z.number().min(0).max(100),
})
export type OverrideRateRow = z.infer<typeof overrideRateRowSchema>

export const overrideRateResponseSchema = z.object({
  from: z.string(),
  to: z.string(),
  group_by: overrideRateGroupBySchema,
  totals: overrideRateTotalsSchema,
  rows: z.array(overrideRateRowSchema),
  rendered_sql: z.string().nullable(),
})
export type OverrideRateResponse = z.infer<typeof overrideRateResponseSchema>
